import controller from './vd-dropdown.controller'
import template from './vd-dropdown.html'

export default {
  bindings: {
    source: '<',
    disabled: '<?',
    inline: '<?',
    fluidWidth: '<?',
    case: '@?',
    lazyLoad: '<?',
    prefill: '@?',
  },
  controller,
  template,
  require: {
    ngModelCtrl: 'ngModel',
  },
}
